import { PresetViewSupportedView } from '@bringg/types';

import { alertsViewProvider } from 'bringg-web/stores/alerts-view/alerts-view-provider';
import { defaultOrderedColumnOptions as taskAlertDefaultColumnOptions } from './task-alert-columns';
import { defaultOrderedColumnOptions as driverAlertDefaultColumnOptions } from './driver-alert-columns';
import { defaultOrderedColumnOptions as optimisationAlertDefaultColumnOptions } from './optimisation-alert-columns';

export const getDefaultColumnOptionsByView = (view: PresetViewSupportedView) => {
	const columns =
		{
			[PresetViewSupportedView.OrderAlerts]: taskAlertDefaultColumnOptions,
			[PresetViewSupportedView.DriverAlerts]: driverAlertDefaultColumnOptions,
			[PresetViewSupportedView.OptimisationAlerts]: optimisationAlertDefaultColumnOptions
		}[view] || [];

	return alertsViewProvider.filterDefaultColumnsByFeatureFlags(columns);
};
